import { useState } from 'react';
import { useDispatch } from 'react-redux';
import WorkspaceSystem from '../../systems/WorkspaceSystem';
import CreateOrEditContactGroupModalPresenter, { type CreateOrEditContactGroupModalPresenterParams } from './CreateOrEditContactGroupModalPresenter';

const useCreateOrEditContactGroupModalPresenter = ( {
	workspaceID, mode, contactGroup, onClose
}: Omit<CreateOrEditContactGroupModalPresenterParams, 'workspaceSystem' | 'snackbarSystem'> ) => {
	const dispatch = useDispatch();
	const workspaceSystem = new WorkspaceSystem( dispatch );

	const createPresenter = () => new CreateOrEditContactGroupModalPresenter( {
		workspaceID,
		mode,
		contactGroup,
		onClose,
		workspaceSystem
	} );

	const [ presenter ] = useState( createPresenter );

	return presenter;
};

export default useCreateOrEditContactGroupModalPresenter;
